import { render, staticRenderFns } from "./quandialog.vue?vue&type=template&id=65999405&scoped=true"
import script from "./quandialog.vue?vue&type=script&lang=js"
export * from "./quandialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65999405",
  null
  
)

export default component.exports